import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { META_PIXEL_ID, initMetaPixel, trackPageView } from '../utils/metaPixel';

/**
 * El base code (fbq('init', ...) + fbq('track', 'PageView')) se ejecuta en index.tsx,
 * antes de montar React, para que corra en la página publicada en cada carga.
 * Este componente solo agrega el PageView de las navegaciones internas (SPA).
 */
export function MetaPixel() {
  const {
    pathname
  } = useLocation();
  const firstRender = useRef(true);
  useEffect(() => {
    // Garantiza el base code incluso si el bootstrap no lo ejecutó.
    initMetaPixel();
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    trackPageView();
  }, [pathname]);
  return <noscript data-id="element-23" data-mp="22xt386ptou0c">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-24" data-mp="231gx56z6jifl" />
    </noscript>;
}